<template>
  <b-form-group
    label="Özet Metin"
    label-for="brief_description"
  >
    <b-form-textarea
      id="brief_description"
      v-model="dataItem.versionOptions.brief_description"
      placeholder="Özet Metin"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'SFVOBriefDescriptionCard',
  components: {
    BFormGroup,
    BFormTextarea,
  },
  computed: {
    dataItem() {
      return this.$store.getters['serviceFiles/dataItem']
    },
  },
}
</script>
